var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useCallback, memo, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { StyledButton, StyledLoader, StyledText } from './Button.styled';
import IconWrapper from '../../core/IconWrapper';
import Spin from '../../core/Spin';
import { buildDataAttr, DATA_TEST } from '../../typings/data';
import { iconSizes, loaderSizes } from './constant';
import { defaultThemeButton } from './Button.skins';
import { mergeTheme } from '../../utils/mergeTheme';
const Loader = memo(({
  skin,
  size
}) => {
  const color = ['transparent-light', 'gray', 'white'].includes(skin) ? 'blue' : 'white';
  return React.createElement(Spin, {
    size: loaderSizes[size],
    color: color
  });
});
export const defaultProps = {
  [DATA_TEST]: 'button',
  skin: 'blue',
  type: 'button',
  tag: 'button',
  isLoading: false,
  isDisabled: false
};
export const Button = _a => {
  var {
    skin = defaultProps.skin,
    type = defaultProps.type,
    tag = defaultProps.tag,
    isLoading = defaultProps.isLoading,
    isDisabled = defaultProps.isDisabled,
    size,
    isFullWidth,
    href,
    rel,
    target,
    onRef,
    leftIcon,
    rightIcon,
    onClick,
    children,
    name,
    value,
    isSpaceBetweenIcon
  } = _a,
      otherProps = __rest(_a, ["skin", "type", "tag", "isLoading", "isDisabled", "size", "isFullWidth", "href", "rel", "target", "onRef", "leftIcon", "rightIcon", "onClick", "children", "name", "value", "isSpaceBetweenIcon"]);

  const context = useContext(ThemeContext);
  const theme = mergeTheme(defaultThemeButton, context);
  const onClickButton = useCallback(e => {
    if (onClick && !isLoading) {
      onClick(e);
    }
  }, [onClick, isLoading]);
  const ComponentTag = href ? 'a' : tag;
  const disabledProps = isDisabled && ['button', 'input'].includes(ComponentTag) ? {
    disabled: true
  } : {};
  const dataAttr = buildDataAttr(otherProps, defaultProps);
  const lIcon = leftIcon && leftIcon[iconSizes[size]];
  const rIcon = rightIcon && rightIcon[iconSizes[size]];
  return React.createElement(StyledButton, Object.assign({
    as: ComponentTag,
    type: ComponentTag === 'button' ? type : undefined,
    href: href,
    rel: rel,
    ref: onRef,
    target: target,
    "data-role": "button",
    isFullWidth: isFullWidth,
    size: size,
    isDisabled: isDisabled,
    onClick: onClickButton,
    skin: skin,
    rightIcon: rightIcon,
    leftIcon: leftIcon,
    isLoading: isLoading,
    name: name,
    value: value,
    isNoChildren: !!children,
    isSpaceBetweenIcon: isSpaceBetweenIcon,
    theme: theme
  }, disabledProps, dataAttr), lIcon && React.createElement(IconWrapper, null, lIcon), children && React.createElement(StyledText, null, children), rIcon && React.createElement(IconWrapper, null, rIcon), isLoading && React.createElement(StyledLoader, null, React.createElement(Loader, {
    size: size,
    skin: skin
  })));
};